import React, { useEffect, useState } from 'react';
import { faEdit, faUser } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Pagination, Tag } from 'antd';
import dayjs from 'dayjs';
import secureLocalStorage from 'react-secure-storage';

import { ContainerChangeLog } from './styled';
import { deleteLog, getLogs, getUsuarioLog, postLogs, putLogs } from '../../../services/timeLine';
import Carregando from '../../../Components/CustomUi/loading';
import { decodeHtml } from '../../../services/Afins';
import ButtonCustom from '../../../Components/ButtonCustom';
import { Render } from '../../../Components/CustomUi/render';
import { cores, dadosFilter } from './components/meta';
import { FormularioHistorico } from './components/formulario';
import { DeleteButton } from '../../../Components/CustomUi/deleteButton';

interface ChangeLogProps {
    onClose?: () => void;
}

const ChangeLog: React.FC<ChangeLogProps> = ({ onClose }) => {
    const [loading, setLoading] = useState(false);
    const [dataLogs, setDataLogs] = useState([]);
    const [totalItems, setTotalItems] = useState(0);
    const [currentPage, setCurrentPage] = useState(1);
    const pageSize = 10;

    const [dataUsuarioLog, setDataUsuarioLog] = useState([])
    const [activeFilter, setActiveFilter] = useState<number | null>(null);
    const [openForm, setOpenForm] = useState(false);
    const [updateId, setUpdateId] = useState(0);
    const [expandedItems, setExpandedItems] = useState<number[]>([]);
    const [confirmar_exclusao, setConfirmar_exclusao] = useState<boolean>(false)
    const [id_item_atual, setId_item_atual] = useState<number>(null)
    const [nome_item_atual, setNome_item_atual] = useState<string>('')
    const [fake_loading, setFake_loading] = useState<boolean>(false)

    // Form fields state
    const [tipoLog, setTipoLog] = useState<string>("");
    const [tipoLogID, setTipoLogID] = useState<number>(0);
    const [titulo, setTitulo] = useState<string>("");
    const [usuario, setUsuario] = useState<string>("");
    const [usuarioID, setUsuarioID] = useState<number>(0);
    const [branch, setBranch] = useState<string>("");
    const [descricao, setDescricao] = useState<string>("");
    const [versao, setVersao] = useState<string>("");
    const [subLogs, setSubLogs] = useState<any[]>([]);
    const [showOutrosLogs, setShowOutrosLogs] = useState(false);
    const [novoSubLogTipo, setNovoSubLogTipo] = useState<string>("");
    const [novoSubLogTipoID, setNovoSubLogTipoID] = useState<number>(0);
    const [novoSubLogDesc, setNovoSubLogDesc] = useState<string>("");
    const [novoSubLogPrivado, setNovoSubLogPrivado] = useState<boolean>(false);

    const buscarLogs = async (page: number, tipo?: number | null) => {
        setLoading(true);
        try {
            const response = await getLogs({
                embed: 'logs',
                page: page,
                limit: pageSize,
            });

            let itens = response?.data?.itens || [];
            const total = response?.data?.total || response?.data?.count || itens.length;

            if (tipo !== null && tipo !== undefined) {
                // Fallback filter if backend doesn't support filter by tipo out of the box
                itens = itens.filter((item: any) => item.tipo === tipo);
            }

            setDataLogs(itens);
            setTotalItems(total);
        } catch (error) {
            console.error('Error fetching logs', error);
        } finally {
            setLoading(false);
        }
    };

    const listUsuarioLog = async () => {
        const response = await getUsuarioLog()
        setDataUsuarioLog(response.data.itens)
    }

    useEffect(() => {
        if (!openForm) {
            buscarLogs(currentPage, activeFilter);
        }
    }, [currentPage, activeFilter, openForm]);

    const mudarPagina = (page: number) => {
        setCurrentPage(page);
    };

    const filtrarClique = (cod: number | null) => {
        setActiveFilter(cod);
        setCurrentPage(1);
    };

    const substituirAsc = (str: string) => {
        let remove = str?.replace(/quot;|&amp;/g, '"');
        return remove ?? str;
    };

    const isAdmin = secureLocalStorage.getItem('acesso-admin') === 1;

    const toggleExpand = (id: number) => {
        setExpandedItems(prev =>
            prev.includes(id) ? prev.filter(i => i !== id) : [...prev, id]
        );
    };

    const handleDelete = async (id: number) => {
        setFake_loading(true)
        await deleteLog(id);
        buscarLogs(currentPage, activeFilter);
        setTimeout(() => {
            setFake_loading(false)
        }, 500);
    };

    const limparFormulario = () => {
        setTitulo("");
        setDescricao("");
        setTipoLog("");
        setTipoLogID(0);
        setBranch("");
        setSubLogs([]);
        setNovoSubLogDesc("");
        setNovoSubLogTipo("");
        setNovoSubLogTipoID(0);
        setNovoSubLogPrivado(false);
        setUsuario("");
        setUsuarioID(0);
        setVersao("");
    };

    const handleEditar = (item: any) => {
        setUpdateId(item.cod);
        setTitulo(decodeHtml(item.titulo || ""));
        setDescricao(decodeHtml(item.descricao || ""));

        // Find name of log type matching ID, or use item.tipo_nome if it's there
        const tipoLogNome = item.tipo_nome || dadosFilter.find(f => f.cod === item.tipo)?.nome || "";
        setTipoLog(tipoLogNome);
        setTipoLogID(item.tipo || 0);

        setBranch(item.branch || "");
        setVersao(item.versao || "");
        setUsuario(item.usuario_nome || "");
        setUsuarioID(item.cod_usuario || 0);

        if (item.logs && Array.isArray(item.logs)) {
            setSubLogs(item.logs.map((log: any) => ({
                ...log,
                privado: log.privado === 1 || log.privado === true
            })));
        } else {
            setSubLogs([]);
        }
        setShowOutrosLogs(true)
        setOpenForm(true);
    };

    const salvarLog = async () => {
        setFake_loading(true);
        try {
            const arrayLogs = subLogs.map((item) => {
                if (item?.cod?.length > 10) {
                    return {
                        ...item,
                        cod: null, // Define cod como null se o comprimento for maior que 10
                    }
                }
                return item
            })

            let response;

            if (updateId > 0) {
                const dados = {
                    titulo: titulo,
                    descricao: descricao,
                    aplicacao: 1,
                    tipo: tipoLog,
                    branch: branch,
                    cod_usuario: usuarioID,
                    logs: arrayLogs,
                    versao: "1.0",
                    logs_remover: [],
                }

                response = await putLogs(
                    dados,
                    updateId,
                    setTitulo,
                    setDescricao,
                    setTipoLog,
                    setBranch,
                    setSubLogs,
                    setNovoSubLogDesc,
                    setNovoSubLogTipo,
                    setNovoSubLogTipoID,
                    setNovoSubLogPrivado,
                    setUsuario,
                    setUsuarioID,
                )
            } else {
                const dados = {
                    titulo: titulo,
                    descricao: descricao,
                    aplicacao: 1,
                    tipo: tipoLogID,
                    branch: branch,
                    cod_usuario: usuarioID,
                    logs: arrayLogs,
                    version: process.env.REACT_APP_VERSION,
                }

                response = await postLogs(
                    dados,
                    setTitulo,
                    setDescricao,
                    setTipoLog,
                    setBranch,
                    setSubLogs,
                    setNovoSubLogDesc,
                    setNovoSubLogTipo,
                    setNovoSubLogTipoID,
                    setNovoSubLogPrivado,
                    setUsuario,
                    setUsuarioID,
                )
            }

            if (response) {
                setOpenForm(false);
                buscarLogs(currentPage, activeFilter);
            }
        } catch (error) {
            console.error(error);
        } finally {
            setFake_loading(false);
        }
    };

    useEffect(() => {
        listUsuarioLog()
    }, [])

    return (
        <ContainerChangeLog>
            <div className="filters">
                <button
                    className={`filter-btn ${activeFilter === null ? 'active' : ''}`}
                    onClick={() => filtrarClique(null)}
                >
                    Todas
                </button>
                {dadosFilter?.map((filter) => (
                    <button
                        key={filter.cod}
                        className={`filter-btn ${activeFilter === filter.cod ? 'active' : ''}`}
                        onClick={() => filtrarClique(filter.cod)}
                    >
                        {filter.nome}
                    </button>
                ))}
            </div>

            <div className="timeline-container">
                <Render condition={loading}>

                    <Carregando animation legenda='Carregando histórico...' justifyContent='center' direction='column' height={500} />

                </Render>
                <Render condition={dataLogs.length === 0}>
                    <p style={{ textAlign: 'center', color: '#999', marginTop: '20px' }}>Nenhum log encontrado.</p>
                </Render>
                <Render condition={!loading && dataLogs.length > 0}>
                    {dataLogs.map((item) => {
                        const configCores = cores[item.tipo as keyof typeof cores] || cores[1];

                        return (
                            <div className={`timeline-item ${expandedItems.includes(item.cod) ? 'expanded' : ''}`} key={item.cod}>
                                <div className="left-column">
                                    <div
                                        className="version-badge"
                                        style={{
                                            backgroundColor: configCores.bg,
                                            color: configCores.text,
                                            border: `2px solid ${configCores.text}`
                                        }}
                                    >
                                        {item.versao || 'N/A'}
                                    </div>
                                    <div className="line"></div>
                                </div>

                                <div className="right-column" onClick={() => toggleExpand(item.cod)}>
                                    <div className="item-header">
                                        <h3>{decodeHtml(item.titulo)}</h3>
                                        <div className="date">{dayjs(item.create_time).format('DD/MM/YYYY')} às {dayjs(item.create_time).format('HH:mm')}</div>
                                    </div>

                                    <div className="tags">
                                        {(() => {
                                            const allLogs = item?.logs?.length ? [item, ...item.logs.filter((l: any) => isAdmin || !l.privado)] : [item];
                                            const uniqueTags = new Map();

                                            allLogs.forEach((logItem: any) => {
                                                const tipo = logItem?.tipo || item?.tipo;
                                                const nome = logItem?.tipo_nome || item?.tipo_nome || dadosFilter.find(f => f.cod === tipo)?.nome || 'LOG';

                                                if (tipo && !uniqueTags.has(tipo)) {
                                                    uniqueTags.set(tipo, nome);
                                                }
                                            });

                                            return Array.from(uniqueTags.entries()).map(([tipo, nome], idx) => {
                                                const tagConfig = cores[tipo as keyof typeof cores] || cores[1];
                                                return (
                                                    <Tag
                                                        key={idx}
                                                        className="tag"
                                                        color={tagConfig.bg}
                                                        style={{
                                                            color: tagConfig.text,
                                                            border: `1px solid ${tagConfig.text}`
                                                        }}
                                                    >
                                                        {nome.toUpperCase()}
                                                    </Tag>
                                                );
                                            });
                                        })()}
                                    </div>

                                    <div className="description">
                                        {substituirAsc(decodeHtml(item.descricao))}
                                    </div>

                                    <div className={`expanded-wrapper ${expandedItems.includes(item.cod) ? 'open' : ''}`}>
                                        <div className="expanded-content">
                                            <div className="inner-content">
                                                {item.logs && item.logs.filter((rec: any) => isAdmin || !rec.privado).map((rec: any, index: number) => (
                                                    <div key={rec.cod || index} className="sub-log-item">
                                                        <span style={{ color: configCores.text, fontWeight: 'bold' }}>•</span> {substituirAsc(decodeHtml(rec.descricao))}
                                                    </div>
                                                ))}

                                                {isAdmin && (
                                                    <div className="admin-actions">
                                                        <ButtonCustom
                                                            type="primary"
                                                            onClick={() => handleEditar(item)}
                                                            icon={<FontAwesomeIcon icon={faEdit} />}
                                                        >
                                                            Editar
                                                        </ButtonCustom>
                                                        <DeleteButton
                                                            open={confirmar_exclusao && id_item_atual === item?.cod}
                                                            trigger={setConfirmar_exclusao}
                                                            onTrigger={() => {
                                                                setId_item_atual(item?.cod)
                                                                setNome_item_atual(item?.nome)
                                                            }}
                                                            loading={fake_loading}
                                                            message={`o item ${item?.nome} será excluido!`}
                                                            deleteds={[item?.nome]}
                                                            onDelete={() => {
                                                                handleDelete(item?.cod)
                                                            }}
                                                            textButtonTrigger='Excluir'
                                                            disabled={fake_loading} />
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                    </div>

                                    <div className="author">
                                        <div style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                                            <FontAwesomeIcon icon={faUser} />
                                            <strong>{item.usuario_nome || 'Sistema'}</strong>
                                        </div>
                                        <span>{item?.branch}</span>
                                    </div>
                                </div>
                            </div>
                        );
                    })}
                </Render>
            </div >

            <div className="pagination-container">
                <Pagination
                    current={currentPage}
                    pageSize={pageSize}
                    total={totalItems}
                    onChange={mudarPagina}
                    showSizeChanger={false}
                />
            </div>

            {
                isAdmin && (
                    <div className="actions" style={{ position: 'fixed', bottom: '20px', right: '20px', zIndex: 10 }}>
                        <button className="add-btn" onClick={() => {
                            setUpdateId(0);
                            setOpenForm(true);
                        }}>
                            +
                        </button>
                    </div>
                )
            }

            <FormularioHistorico
                onCancel={() => {
                    setOpenForm(false);
                    limparFormulario();
                    setUpdateId(0);
                }}
                isLoading={fake_loading}
                update={updateId}
                dadosLogs={dataLogs}
                dataUsuarioLog={dataUsuarioLog}
                openForm={openForm}
                tipoLog={tipoLog}
                setTipoLog={setTipoLog}
                titulo={titulo}
                setTitulo={setTitulo}
                usuario={usuario}
                setUsuario={setUsuario}
                branch={branch}
                setBranch={setBranch}
                descricao={descricao}
                setDescricao={setDescricao}
                subLogs={subLogs}
                setSubLogs={setSubLogs}
                showOutrosLogs={showOutrosLogs}
                setShowOutrosLogs={setShowOutrosLogs}
                novoSubLogTipo={novoSubLogTipo}
                setNovoSubLogTipo={setNovoSubLogTipo}
                novoSubLogTipoID={novoSubLogTipoID}
                setNovoSubLogTipoID={setNovoSubLogTipoID}
                novoSubLogDesc={novoSubLogDesc}
                setNovoSubLogDesc={setNovoSubLogDesc}
                novoSubLogPrivado={novoSubLogPrivado}
                setNovoSubLogPrivado={setNovoSubLogPrivado}
                tipoLogID={tipoLogID}
                setTipoLogID={setTipoLogID}
                usuarioID={usuarioID}
                setUsuarioID={setUsuarioID}
                versao={versao}
                setVersao={setVersao}
                salvarLog={salvarLog}
            />
        </ContainerChangeLog >
    );
};

export default ChangeLog;
